function waitFor(ms = 200) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(true), ms);
  });
}

export { waitFor };
